//Don't change the order!!!
export const BATCHES = [
  {
    value: "breakfast",
    label: "Break Fast"
  },
  {
    value: "lunch",
    label: "Lunch"
  },
  {
    value: "evening_snacks",
    label: "Evening Snacks"
  },
  {
    value: "dinner",
    label: "Dinner"
  }
];
